export var StakingInstructions;
(function (StakingInstructions) {
    StakingInstructions[StakingInstructions["InitStakingPool"] = 0] = "InitStakingPool";
    StakingInstructions[StakingInstructions["CreateStakeAccount"] = 1] = "CreateStakeAccount";
    StakingInstructions[StakingInstructions["Deposit"] = 2] = "Deposit";
    StakingInstructions[StakingInstructions["Withdraw"] = 3] = "Withdraw";
    StakingInstructions[StakingInstructions["ClaimReward"] = 4] = "ClaimReward";
    StakingInstructions[StakingInstructions["UpdateEarliestRewardClaimTime"] = 5] = "UpdateEarliestRewardClaimTime";
})(StakingInstructions || (StakingInstructions = {}));
//# sourceMappingURL=instruction.js.map